import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameConfigDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Game Config Details"}
                            endpoint={"game-config/details"}
                            relations={["provider", "game_tag", "operator_game_configs", "operator_game_configs.operator"]}
                            manyToManyRelations={[{
                                name: "operator_game_configs",
                                title: "Operators",
                                columnTitles: ["Operator", "Internal Game ID", "Vendor Game ID"],
                                objectKeys: ["operator.company_name", "internal_game_id", "provider_game_id"],
                                
                            }]} />
}

export default GameConfigDetailsPage;